import { makeStyles } from '@material-ui/core';
import { colors } from 'theme/colors';

export const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(2),
  },
  fullHeight: {
    height: '80%',
  },
  row: {
    cursor: 'pointer',
  },
  tCell: {
    padding: '16px',
  },
  emptyBox: {
    margin: '0 auto',
    padding: theme.spacing(4, 0),
    height: '100%',
    maxWidth: 406,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyText: {
    fontWeight: 500,
    fontSize: 24,
    textAlign: 'center',
  },
  avatar: {
    color: colors.WHITE,
    backgroundColor: colors.PRIMARY,
    textTransform: 'uppercase',
    border: 'none',
  },
  paperLoading: {
    minHeight: 200,
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2),
  },
}));
